import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";
import { PANEL_STATES } from "../../../state/reducers/projectWizard/projectWizardConstants.js";

class SSHPanelSummary extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    // resourceType: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    configCopyKey: PropTypes.string,
    configOptions: PropTypes.object,
    copyKey: PropTypes.string.isRequired,

    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "ssh_keys"
  };

  // -- RENDER -- //

  renderActive() {
    const {
      id,
      formikProps: { values },
      copyKey,
      copy
    } = this.props;

    const sshKeys = values[id] || [];

    return (
      <p>
        <strong>{copy(`${copyKey}.title`)}: </strong>
        {sshKeys.length} {copy(`${copyKey}.summary.added`)}
      </p>
    );
  }

  renderSkipped() {
    const { copyKey, copy } = this.props;
    return (
      <p>
        <strong>{copy(`${copyKey}.title`)}: </strong>
        {copy(`${copyKey}.summary.skipped`)}
      </p>
    );
  }

  renderInactive() {
    return null;
  }

  render() {
    const {
      id,
      formikProps: { values }
    } = this.props;

    const sshKeys = values[id] || [];

    if (sshKeys === PANEL_STATES.SKIPPED) {
      return this.renderSkipped();
    }

    if (sshKeys.length > 0) {
      return this.renderActive(sshKeys);
    }

    return this.renderInactive();
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(SSHPanelSummary);
